import ProductCard from "components/ProductCard";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import tomato1 from "../assets/images/tomato 1.png";
import tomato2 from "../assets/images/tomato 2.png";
import tomato3 from "../assets/images/tomato 3.png";

type ProductItem = {
  id: string;
  name: string;
  price: number;
  unitLabel: string;
  rating: number;
  vendorName: string;
  imageUrl: string;
};

const products: ProductItem[] = [
  {
    id: "1",
    name: "Tomato",
    price: 89,
    unitLabel: "(1 Kg)",
    rating: 2.1,
    vendorName: "FreshMart",
    imageUrl: tomato1, // ✅ correct
  },
  {
    id: "2",
    name: "Tomato Premium",
    price: 120,
    unitLabel: "(1 Kg)",
    rating: 4.3,
    vendorName: "FreshMart",
    imageUrl: tomato2, // ✅ correct
  },
  {
    id: "3",
    name: "Tomato Organic",
    price: 75,
    unitLabel: "(500 g)",
    rating: 3.8,
    vendorName: "VeggieHub",
    imageUrl: tomato3, // ✅ correct
  },
  {
    id: "4",
    name: "Tomato",
    price: 60,
    unitLabel: "(250 g)",
    rating: 4.0,
    vendorName: "GreenBasket",
    imageUrl: tomato1,
  },
  {
    id: "5",
    name: "Tomato",
    price: 60,
    unitLabel: "(250 g)",
    rating: 4.0,
    vendorName: "GreenBasket",
    imageUrl: tomato3,
  },
  {
    id: "6",
    name: "Tomato",
    price: 60,
    unitLabel: "(250 g)",
    rating: 4.0,
    vendorName: "GreenBasket",
    imageUrl: tomato2,
  },
  {
    id: "7",
    name: "Tomato",
    price: 60,
    unitLabel: "(250 g)",
    rating: 4.0,
    vendorName: "GreenBasket",
    imageUrl: tomato1,
  },
  {
    id: "8",
    name: "Tomato",
    price: 60,
    unitLabel: "(250 g)",
    rating: 4.0,
    vendorName: "GreenBasket",
    imageUrl: tomato2,
  },
];

const Product: React.FC = () => {
  return (
    <Container className="py-3">
      <Row className="g-4">
        {products.map((p) => (
          <Col key={p.id} xs={12} sm={6} lg={4} xl={3}>
            <ProductCard
              name={p.name}
              price={p.price}
              unitLabel={p.unitLabel}
              rating={p.rating}
              vendorName={p.vendorName}
              imageUrl={p.imageUrl}
              onAddToCart={() => console.log("Add to cart:", p.id)}
            />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Product;